import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import LatestUpdates from './components/LatestUpdates';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema
        type="WebPage"
        data={{
          name: '乳色吐息动漫 — 官方正版资源与剧情解析',
          description: '乳色吐息动漫完整剧情介绍、角色分析与观看指南。深入解析乳色吐息动漫的故事背景、人物关系与艺术风格。',
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedArticles />
        <LatestUpdates />
        <FAQSection />
      </main>
      <Footer newsletterSubmitAddr="https://readdy.ai/api/form/d9st0fllbrt1qcgaj9n0" />
    </>
  );
}